// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"fX-z","subtitle":"gX-z","wrapper":"hX-z","leftArrow":"iX-z","rightArrow":"jX-z"};